import React, { useState } from "react";
import {Typography,Box,Button,TextField,IconButton} from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { submitPreScam, submitScam } from "src/redux/scam/scamActions";
import { showToast } from "src/redux/common/commonActions";

const PostScam = ({
  setIsViewMyReports = () => { },
  isViewMyReports = false,
  isPrepostScam = false,
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { first_name, id: user_id } = useSelector((state) => state.userState.userData);
  const { loading: scamLoading } = useSelector(state => state.scamState)
  const message = useSelector(state => state.scamState?.scamData?.message)
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    if (uploadedFiles.length + files.length <= 6) {
      setUploadedFiles((prev) => [...prev, ...files]);
    } else {
      alert("You can upload a maximum of 6 files.");
    }
  };

  const removeFile = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    if (!description.trim()) {
      setError("Write a description.");
      return;
    }

    setError("");
    const formData = new FormData();
    formData.append("description", description);
    formData.append("user_id", user_id);
    uploadedFiles.forEach((file, index) => {
      formData.append(`file_${index}`, file);
    });

    // Convert FormData to a plain object, handling files separately
    const formObject = {
      description,
      user_id,
      files: uploadedFiles.map((file) => ({
        name: file.name,
        type: file.type,
        size: file.size,
        file,  // Keeping the original file object for uploads later if needed
      })),
    };

    if (isPrepostScam) {
      dispatch(submitPreScam(formObject));
      dispatch(
        showToast({ show: true, msg: "Kindly sign in first..." })
      );
      navigate('/login')
    } else {
      try {
        dispatch(submitScam(formData));
        setDescription("");
        setUploadedFiles([]);
        dispatch(showToast({ show: true, msg: message || 'Report added successfully!' }));
      } catch (error) {
        console.error("Error submitting scam report:", error);
        dispatch(showToast({ show: true, msg: message || 'Error in reporting scam!' }));
      }
    }

  };


  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          borderRadius: 2,
          boxShadow: 1,
          padding: "2rem",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            variant="h6"
          // sx={{
          //   fontWeight: 600,
          //   lineHeight: 1.5,
          //   fontSize: "1.1rem",
          //   fontFamily: "Roboto",
          //   color: "#212B36",
          //   paddingBottom: ".15rem",
          //   textAlign: "left",
          // }}
          >
            {
              !isPrepostScam && `Hey ${first_name}!`
            }

          </Typography>
          {
            !isPrepostScam &&
            <Typography
              variant="body2"
              sx={{
                color: "#616161",
                cursor: "pointer",
                ":hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={() => {
                setIsViewMyReports(val => !val)
              }}
            >
              {!isViewMyReports ? 'view my reports' : 'show alerts'}
            </Typography>
          }
        </Box>
        <Typography variant="body1">Found a scammer to report?</Typography>

        <TextField
          variant="outlined"
          placeholder="Comment"
          fullWidth
          multiline
          rows={5}
          sx={{ backgroundColor: "white", borderRadius: 1 }}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          error={!!error}
          helperText={error}
        />

        <Box
          sx={{display: "flex",justifyContent: "space-between",alignItems: "center"}}
        >
          <Button
            variant="outlined"
            component="label"
            startIcon={<AddPhotoAlternateIcon />}
            sx={{ textTransform: "none" }}
          >
            Attach Files
            <Box
              component="span"
              sx={{
                display: { xs: "none", sm: "inline" },
              }}
            >
              (Images)
            </Box>
            <input
              type="file"
              accept="image/*"
              multiple
              hidden
              onChange={handleFileUpload}
            />
          </Button>

          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: "#6d4cb1",
              ":hover": { backgroundColor: "#402c69" },
            }}
            onClick={handleSubmit}
            disabled={scamLoading}
          >
            {scamLoading ? 'Posting..' : 'Post'}
          </Button>
        </Box>

        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
          {uploadedFiles.map((file, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                backgroundColor: "#f1f1f1",
                padding: 0.5,
                borderRadius: 1,
                fontSize: "0.75rem",
                minWidth: "120px",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  maxWidth: 100,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  fontSize: "0.75rem",
                }}
              >
                {file.name}
              </Typography>
              <IconButton
                size="small"
                onClick={() => removeFile(index)}
                sx={{ padding: 0.25 }}
              >
                &times;
              </IconButton>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default PostScam;
